module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAABAElEQVQokY3TvyvGURTH8Zc8A7OBJAaZWCS/IqvJaLHh/0Ipi9FkVmzIIFEiGfQkEeVHoqPzLT157uMz3e4973s+59xzYQor6PBPtWMek5jAFR5aoQEd4QmjmEUNF/gqQaFrHGIQ4xjBOV5KkAzYz70xzKSDmxIkLZ1lluFsUl/uvTeDKt3jAF2ZNeBb1EtQ6CPrrGeTwm4/3kpQpchwiWn0oLf2DyjebynXJ9hrKwR3ZnBAj9jAaRw0g4awnI04xiaeq8NGKGpcyNGKRmyHncYbf0PdWMVAzuAa7v6yUUFzWMy528UOPpsVG1B8i5jyeND1HNai4uafjmALr60A+AZOQjVdLSiXdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/arrow-right.png
// module id = 1315
// module chunks = 61